import React from "react";

const WarningIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73197 3.56641C8.96217 2.23307 7.03767 2.23307 6.26787 3.56641L1.07171 12.5664C0.301914 13.8997 1.26417 15.5664 2.80377 15.5664H13.1961C14.7357 15.5664 15.6979 13.8997 14.9281 12.5664L9.73197 3.56641ZM8.86504 8.41401V7.15038C8.86504 6.84218 8.80853 6.57336 8.69552 6.34392C8.58252 6.11448 8.35821 5.99976 8.02261 5.99976C7.69044 5.99976 7.46442 6.11276 7.34457 6.33878C7.22813 6.56137 7.16992 6.82848 7.16992 7.14011V8.39347L7.43703 10.0578C7.43703 10.2906 7.47127 10.4927 7.53976 10.6639C7.61168 10.8351 7.77263 10.9207 8.02261 10.9207C8.2726 10.9207 8.43184 10.8351 8.50033 10.6639C8.57224 10.4927 8.6082 10.2906 8.6082 10.0578L8.86504 8.41401ZM8.64416 12.9857C8.79141 12.8453 8.86504 12.6295 8.86504 12.3385C8.86504 12.044 8.79483 11.8299 8.65443 11.6964C8.51745 11.5628 8.30685 11.496 8.02261 11.496C7.74865 11.496 7.53805 11.5628 7.3908 11.6964C7.24354 11.8299 7.16992 12.044 7.16992 12.3385C7.16992 12.9069 7.45415 13.1912 8.02261 13.1912C8.28972 13.1912 8.4969 13.1227 8.64416 12.9857Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { WarningIcon };
